import { makeStyles } from "@material-ui/core";
import { get } from "lodash";
import React, { Fragment } from "react";
import {
	EditButton,
	ImageField,
	List as RaList,
	NumberField,
	TextField,
	useReference,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import CloneButton from "./buttons/CloneButton";
import Filters from "./Filters";

const useStyles = makeStyles((theme) => ({
	image: {
		"& img": { width: 70, height: 70, objectFit: "cover" },
	},
}));

const Datagrid = (props) => {
	const classes = useStyles();
	const hasContestFilter = get(props, "filterValues.contest_id");
	const { referenceRecord } = useReference({
		id: hasContestFilter,
		reference: "contests",
	});
	const contestType = get(referenceRecord, "type");

	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField source="name" style={{ fontWeight: "bold" }} />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
					<TextField
						source="contest.title"
						label="resources.rewards.fields.contest_id"
					/>
					<ImageField
						source="image.file.path"
						className={classes.image}
						label="resources.rewards.fields.image_media_id"
					/>
					<NumberField source="points_from" />
					<NumberField source="points_to" />
					<NumberField source="ranking_position" />
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					<EditButton />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasContestFilter && (
				<TextField
					source="contest.title"
					label="resources.rewards.fields.contest_id"
					style={{ fontWeight: "bold" }}
				/>
			)}
			<ImageField
				source="image.file.path"
				className={classes.image}
				label="resources.rewards.fields.image_media_id"
			/>
			<TextField source="name" style={{ fontWeight: "bold" }} />
			{contestType === "points" && (
				<Fragment>
					<NumberField source="points_from" />
					<NumberField source="points_to" />
				</Fragment>
			)}
			{contestType === "ranking" && <NumberField source="ranking_position" />}
			<EditButton />
			<CloneButton />
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			filters={<Filters />}
			actions={<Actions />}
			perPage={perPage()}
			exporter={false}
			sort={{ field: "points_from", order: "asc" }}
		>
			<Datagrid />
		</RaList>
	);
};
export default List;
